
import React from 'react';
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const Contact = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <section className="section-padding">
          <div className="container mx-auto px-4 md:px-6">
            <div className="max-w-6xl mx-auto">
              <div className="text-center mb-16">
                <h1 className="text-4xl md:text-5xl font-bold mb-6 text-careblue-800">Contact CountedCare</h1>
                <p className="text-xl text-muted-foreground max-w-3xl mx-auto">
                  Building the future of caregiver financial solutions. Connect with our team for partnerships, investment opportunities, and business inquiries.
                </p>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
                <div className="bg-white rounded-xl p-8 shadow-soft border border-careblue-100">
                  <h3 className="text-xl font-bold mb-4 text-careblue-800">Investment Opportunities</h3>
                  <p className="text-muted-foreground mb-6">
                    Interested in investing in the future of caregiver support? Connect with our leadership team.
                  </p>
                  <div className="bg-careblue-50 p-4 rounded-lg">
                    <p className="font-semibold text-careblue-800">
                      <a href="mailto:investors@countedcare.com" className="hover:underline">
                        investors@countedcare.com
                      </a>
                    </p>
                  </div>
                </div>
                
                <div className="bg-white rounded-xl p-8 shadow-soft border border-careblue-100">
                  <h3 className="text-xl font-bold mb-4 text-careblue-800">Business Development</h3>
                  <p className="text-muted-foreground mb-6">
                    Strategic partnerships, enterprise solutions, and collaboration opportunities.
                  </p>
                  <div className="bg-careblue-50 p-4 rounded-lg">
                    <p className="font-semibold text-careblue-800">
                      <a href="mailto:partnerships@countedcare.com" className="hover:underline">
                        partnerships@countedcare.com
                      </a>
                    </p>
                  </div>
                </div>
                
                <div className="bg-white rounded-xl p-8 shadow-soft border border-careblue-100">
                  <h3 className="text-xl font-bold mb-4 text-careblue-800">Media & Press</h3>
                  <p className="text-muted-foreground mb-6">
                    Press inquiries, media kits, and interview requests for our executive team.
                  </p>
                  <div className="bg-careblue-50 p-4 rounded-lg">
                    <p className="font-semibold text-careblue-800">
                      <a href="mailto:press@countedcare.com" className="hover:underline">
                        press@countedcare.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              
              <div className="bg-careblue-800 text-white rounded-xl p-12 text-center">
                <h2 className="text-3xl font-bold mb-6">Market Opportunity</h2>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
                  <div>
                    <div className="text-4xl font-bold mb-2">53M</div>
                    <p className="text-careblue-100">Americans providing family care</p>
                  </div>
                  <div>
                    <div className="text-4xl font-bold mb-2">$7K+</div>
                    <p className="text-careblue-100">Average annual caregiver expenses</p>
                  </div>
                  <div>
                    <div className="text-4xl font-bold mb-2">26%</div>
                    <p className="text-careblue-100">Of income spent on care costs</p>
                  </div>
                </div>
                <p className="text-lg text-careblue-100 max-w-3xl mx-auto">
                  CountedCare is positioned to capture significant market share in the growing caregiver support technology sector.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Contact;
